import { render } from "./Scores.vue?vue&type=template&id=666e2fd8&scoped=true"
import script from "./Scores.vue?vue&type=script&lang=js"
export * from "./Scores.vue?vue&type=script&lang=js"

import "./Scores.vue?vue&type=style&index=0&id=666e2fd8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cloud-builder-challenge-frontend/cloud-builder-challenge-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666e2fd8"]])

export default __exports__